import { NUsersData } from './interface';

export const baseReducer: NUsersData.Reducer = {
    hi: ''
}